import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { OoivRulesStore } from '../service/ooiv-rules.store';

@Injectable()
export class OoivRulesValidationResolver implements Resolve<any> {
  constructor(private ooivRulesStore: OoivRulesStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const id = route.params['id'];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.OOIV_HEALTH'));
    }
    return this.ooivRulesStore.loadOoivExceptionRules(id);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/ooiv-rules-validation.resolver.ts